import { ParagraphSmall, TamaguiButton, Text, XStack } from "@medbillai/ui";
import { LogoutReason } from "../lib/analytics";
import { useAuth } from "../lib/auth";
import { useLogout } from "../lib/useLogout";
export const ShadowLoginBanner = () => {
  const {
    isReady,
    user
  } = useAuth();
  const logout = useLogout();
  if (!isReady || !user?.isShadow) {
    return null;
  }
  return <XStack gap="$3" ai="center" bc="$red7" p="$3" fg={0} data-sentry-element="XStack" data-sentry-component="ShadowLoginBanner" data-sentry-source-file="ShadowLoginBanner.tsx">
      <ParagraphSmall fg={1} fs={1} data-sentry-element="ParagraphSmall" data-sentry-source-file="ShadowLoginBanner.tsx">
        WARNING: You are currently using Shadow Login mode as{" "}
        <Text bold data-sentry-element="Text" data-sentry-source-file="ShadowLoginBanner.tsx">{user.profile?.email ?? "unknown@unknown.com"}</Text>.
      </ParagraphSmall>
      <TamaguiButton size="$1" onPress={() => logout({
      reason: LogoutReason.SHADOW_LOGOUT,
      useReplace: true
    })} fs={0} data-sentry-element="TamaguiButton" data-sentry-source-file="ShadowLoginBanner.tsx">
        Logout
      </TamaguiButton>
    </XStack>;
};